import axios from 'axios'

export const UserExcuseApi = {
    Type:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/userexcuse/type/update':'/api/userexcuse/type/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/userexcuse/type/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/userexcuse/type/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/userexcuse/type/list')
            return response
        },
    },
    async Create(data){
        const response = await axios.post('/api/userexcuse/create',data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/userexcuse/delete/${data}`)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/userexcuse/table',data)
        return response
    },
    async Approve(data){
        const response = await axios.post(`/api/userexcuse/approve/${data}`)
        return response
    },
}